import React from 'react';

const Hash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M10.5 4C11.0523 4 11.5 4.44772 11.5 5V9.5H20.5V5C20.5 4.44772 20.9477 4 21.5 4C22.0523 4 22.5 4.44772 22.5 5V9.5H27C27.5523 9.5 28 9.94772 28 10.5C28 11.0523 27.5523 11.5 27 11.5H22.5V20.5H27C27.5523 20.5 28 20.9477 28 21.5C28 22.0523 27.5523 22.5 27 22.5H22.5V27C22.5 27.5523 22.0523 28 21.5 28C20.9477 28 20.5 27.5523 20.5 27V22.5H11.5V27C11.5 27.5523 11.0523 28 10.5 28C9.94772 28 9.5 27.5523 9.5 27V22.5H5C4.44772 22.5 4 22.0523 4 21.5C4 20.9477 4.44772 20.5 5 20.5H9.5V11.5H5C4.44772 11.5 4 11.0523 4 10.5C4 9.94772 4.44772 9.5 5 9.5H9.5V5C9.5 4.44772 9.94772 4 10.5 4ZM11.5 11.5V20.5H20.5V11.5H11.5Z" />
  </svg>
);

export default Hash;
